// @flow

// - Stylesheet
import '../inscription/inscription.less';

// - Vendors
import { View } from '@insolus/backbone';

// - Components
import InscriptionStep from '../../../components/inscription-step';

class InscriptionStudent extends View {
    get block(): string { return 'inscription'; }
    get isPrerendered(): boolean { return true; }

    InscriptionStep: InscriptionStep;

    initialize() {
        this.render();
    }

    // ——————————————————————————————————————————————————————
    // —
    // —     Rendering
    // —
    // ——————————————————————————————————————————————————————

    bindElements() {
        this.$step = this.$el.element('step');
    }

    onRender() {
        this.InscriptionStep = new InscriptionStep(this.$step);
    }
}

export default new InscriptionStudent('.inscription');



// WEBPACK FOOTER //
// ./src/views/themes/front/pages/Pages/inscription_student/inscription-student.js